/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import ImageDataParser from "App/utils/textures/image_data_parser";
import TextureDataHandler from "App/utils/textures/texture_data_handler";

export default
class ImageDataLoader {
    protected _textureDataHandler: TextureDataHandler;
    protected _level: number;
    protected _diffuseTextureProperties: any;
    private _parser: ImageDataParser;

    public tiles: any[] = [];
    protected _loadIterator: number = 0;

    protected _typeName: string = "";

    private _nofObservers: number = 0;

    constructor(aTextureDataHandler: TextureDataHandler, aDiffuseTextureProperties: any, aLevel: number) {

        this._textureDataHandler = aTextureDataHandler;
        this._level = aLevel;
        this._diffuseTextureProperties = aDiffuseTextureProperties;
        this._parser = new ImageDataParser(this._diffuseTextureProperties);
    }

    public static getNumMipmapsFromResolution(aWidth: number, aHeight: number) {
        let resolution = Math.max(aWidth, aHeight);

        let i = 0;
        while (resolution > 1) {
            resolution >>= 1;
            i++;
        }

        return i + 1;
    };

    public addObserver() {
        this._nofObservers++;
    }

    public removeObserver() {
        this._nofObservers--;
    }

    public hasObservers(): boolean {
        return this._nofObservers !== 0;
    }

    public cleanupDownloadedData() {
        // we have the tiles already created so we does not need the received texture data
        for (let i = 0; i < this.tiles.length; i++) {
            this.tiles[i].compressedUint8Data = null;
        }
    }

    public cleanupLoadedData() {
        for (let i = 0; i < this.tiles.length; i++) {
            this.tiles[i].cleanupLoadedData();
        }

        this._loadIterator = 0;
    }

    public parse(aResponse: any) {
        this.tiles = this._parser.parse(aResponse);
    }

    public prepareData() {

    }

    public getDiffuseProperties(): any {
        return this._diffuseTextureProperties;
    }

    public getNeedMipmapsGeneration(): boolean
    {
         return false;
    }

    public getLevel(): number {
        return this._level;
    }

    public getCols(): number {
        return this._parser.getCols();
    }

    public getRows(): number {
        return this._parser.getRows();
    }

    public isReady(): boolean {
        let ready = true;
        for (let i = 0; i < this.tiles.length; i++) {
            ready = ready && this.tiles[i].ready;
        }

        return ready;
    }
}
